import React, { useEffect, useState } from "react";
import { api } from "../../lib/api.js";
import { fmtDateTime } from "../../lib/format.js";

export function AuditTab() {
  const [entries, setEntries] = useState([]);
  const [filter, setFilter] = useState({ action: "", record_type: "" });
  useEffect(() => {
    const p = new URLSearchParams();
    if (filter.action) p.append("action", filter.action);
    if (filter.record_type) p.append("record_type", filter.record_type);
    api.get(`/audit-log?${p}`).then((r) => setEntries(r.data));
  }, [JSON.stringify(filter)]);
  return (
    <div>
      <div className="mb-3 flex gap-2">
        <select value={filter.action} onChange={(e) => setFilter({ ...filter, action: e.target.value })} className="px-2 py-1 border border-gray-300 rounded-sm text-sm" data-testid="audit-action-filter">
          <option value="">Todas as acções</option>
          {["Created", "Status changed", "Field updated", "Customer contact logged", "Override used", "Task completed", "Evidence uploaded", "User login"].map((a) => <option key={a}>{a}</option>)}
        </select>
        <select value={filter.record_type} onChange={(e) => setFilter({ ...filter, record_type: e.target.value })} className="px-2 py-1 border border-gray-300 rounded-sm text-sm">
          <option value="">Todos os tipos</option>
          {["service_case", "parts_request", "task", "user"].map((a) => <option key={a}>{a}</option>)}
        </select>
      </div>
      <div className="bg-white border border-gray-200 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F4F6F8] text-[10px] uppercase tracking-wider text-[#6C757D]">
            <tr><th className="px-3 py-2 text-left">Quando</th><th className="px-3 py-2 text-left">Utilizador</th><th className="px-3 py-2 text-left">Acção</th><th className="px-3 py-2 text-left">Tipo</th><th className="px-3 py-2 text-left">Detalhe</th><th className="px-3 py-2 text-left">Comentário</th></tr>
          </thead>
          <tbody>
            {entries.map((e) => (
              <tr key={e.id} className="border-t border-gray-100" data-testid={`audit-entry-${e.id}`}>
                <td className="px-3 py-2 text-xs whitespace-nowrap">{fmtDateTime(e.timestamp)}</td>
                <td className="px-3 py-2 text-xs">{e.user_name}</td>
                <td className="px-3 py-2 text-xs">{e.action}</td>
                <td className="px-3 py-2 text-xs">{e.record_type}</td>
                <td className="px-3 py-2 text-xs text-[#6C757D]">
                  {e.old_value != null && <div>antigo: <span className="font-mono">{JSON.stringify(e.old_value).slice(0, 80)}</span></div>}
                  {e.new_value != null && <div>novo: <span className="font-mono">{JSON.stringify(e.new_value).slice(0, 80)}</span></div>}
                </td>
                <td className="px-3 py-2 text-xs">{e.comment}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}


// ===== Dwell-threshold management =====
